import type { FooterContactProps } from '@/app/components/layouts/footer/contact';

export const FOOTER_CONTACT: FooterContactProps = {
  title: 'ช่องทางการติดต่อ',
  contact: [
    {
      href: 'https://www.tripetchgroup.com/',
      image: 'https://assets.isuzu-tis.com/logo_tripetchgroup_01cd29f437.svg',
      alt: 'ติดต่อกลุ่มตรีเพชร',
      value: 'logo-tripetchgroup',
    },
    {
      href: 'tel:021180777',
      image: 'https://assets.isuzu-tis.com/logo_isuzu_hotline_09762fa8a1.svg',
      alt: 'ISUZU HOTLINE สายด่วน',
      value: 'logo-isuzu-hotline',
    },
  ],
};

export const FOOTER_COPYRIGHT =
  'สงวนลิขสิทธิ์ © 2026 บริษัท ตรีเพชรอีซูซุเซลส์ จำกัด';
